import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TTextDM from './TTextDM'

export default class TWebModuleCategoryItemDM extends Data {
	public static className = 'TWebModuleCategoryItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	Name?: string
	DataModuleNumber?: number
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	IsSubordinateCategoryCalc?: string
	@Type(() => TTextDM)
	UserAccessId?: TTextDM
}